import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';

import styles from './styles.scss';

import { AttachmentTypes } from 'buyside/components/presentation/IdeaShowPage/RightSidebar/Attachments/attachments';
import CollapsibleAttachments from './CollapsibleAttachments';
import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';

import FileTextIcon from 'buyside/svgs/document/file-text.svg';
import PaperStackIcon from 'buyside/svgs/paper_stack.svg';

interface AttachmentProps {
  secondaryResearch: {
    id: string;
    filename: string;
    createdAt: string;
    attachmentType: string;
    fileType: string;
  }[];
  financialModelResearch: {
    id: string;
    filename: string;
    createdAt: string;
    attachmentType: string;
    fileType: string;
  }[];
  isLocked: boolean;
}

const formatHeapTag = (string: string): string =>
  string
    .toLowerCase()
    .split(' ')
    .join('-');

const Attachments: FC<AttachmentProps> = ({
  secondaryResearch,
  financialModelResearch,
  isLocked
}): ReactElement => {
  return (
    <InfoTable dataTag="attachments" title="Attachments" isLocked={isLocked}>
      {(): ReactElement => (
        <div className={classNames(styles.attachmentContainer, styles.innerContainer)}>
          {!!secondaryResearch.length && (
            <div className={styles.itemContainer}>
              <CollapsibleAttachments
                dataTag={formatHeapTag(AttachmentTypes.SecondaryResearch)}
                files={secondaryResearch}
                Icon={PaperStackIcon}
                researchType={AttachmentTypes.SecondaryResearch}
              />
            </div>
          )}
          {!!financialModelResearch.length && (
            <div className={styles.itemContainer}>
              <CollapsibleAttachments
                dataTag={formatHeapTag(AttachmentTypes.FinancialModel)}
                files={financialModelResearch}
                Icon={FileTextIcon}
                researchType={AttachmentTypes.FinancialModel}
              />
            </div>
          )}
        </div>
      )}
    </InfoTable>
  );
};

export default Attachments;
